import React from 'react';

export const BrandMark = () => (
  <div className="lv2-nav-logo" style={{ cursor: 'default' }} data-testid="brand-mark">
    <div className="lv2-logo-mark">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <path d="M3 9h18M9 21V9" />
      </svg>
    </div>
    <div>
      <div className="lv2-wordmark">SCHEDULES OF WORK</div>
      <span className="lv2-nav-sub">RESIDENTIAL REFURB</span>
    </div>
  </div>
);
